module.exports = __webpack_public_path__ + "img/cat-with-blanket.d6b2a7e9.jpg";